module.exports = __webpack_public_path__ + "static/media/music.7d8017e2.svg";